import Button, { ButtonProps } from '@shared/components/Button/Button';
import cx from 'classnames';

interface SecuritySettingsOptionRowProps {
  title: string;
  description: string;
  buttonLabel: string;
  buttonVariant: ButtonProps['variant'];
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  buttonClassName?: string;
}

const SecuritySettingsOptionRow = ({
  title,
  description,
  buttonLabel,
  buttonVariant,
  onClick,
  disabled = false,
  loading = false,
  loadingText,
  buttonClassName,
}: SecuritySettingsOptionRowProps): JSX.Element => (
  <div className="flex w-full flex-col gap-4 xs:flex-row xs:items-start">
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <span className="text-size-md font-medium leading-6 text-grayscale-black">{title}</span>
      <span className="text-size-sm font-light leading-5 text-gray-80">{description}</span>
    </div>
    <Button
      variant={buttonVariant}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      loadingText={loadingText}
      className={cx('min-h-11 min-w-11 w-fit shrink-0 font-medium', buttonClassName)}
    >
      {buttonLabel}
    </Button>
  </div>
);

export default SecuritySettingsOptionRow;
